// Shared codes and names. Pure: imported by the game, the Worker, the Durable Objects and the local mock server.
export const WORDS = ['DIAMOND', 'EMERALD', 'PIXEL', 'ROCKET', 'NINJA', 'DRAGON', 'LAVA', 'THUNDER', 'CRYSTAL', 'TURBO', 'MEGA', 'BLOCK', 'COMET', 'GALAXY', 'LASER', 'STORM', 'BLAZE', 'FROST', 'GOLDEN', 'RUBY', 'TITAN', 'COSMIC', 'HYPER', 'SUPER', 'ROBO', 'NEON', 'JUMBO', 'SONIC', 'POWER', 'MAGIC', 'SHADOW', 'ROYAL'];
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

// Save codes back up one game (WORD-WORD-NNNN). Room codes open one shared world (WORD-NNN).
export const SAVE_RE = /^[A-Z]{2,12}-[A-Z]{2,12}-\d{4}$/;
export const ROOM_RE = /^[A-Z]{2,12}-\d{3}$/;

function randomInts(n) {
  const a = new Uint32Array(n);
  globalThis.crypto.getRandomValues(a);
  return a;
}

export function makeCode() {
  const a = randomInts(3);
  const w1 = WORDS[a[0] % WORDS.length];
  let w2 = WORDS[a[1] % WORDS.length];
  if (w2 === w1) w2 = WORDS[(a[1] + 7) % WORDS.length];
  return `${w1}-${w2}-${(a[2] % 9000) + 1000}`;
}

export function makeRoomCode() {
  const a = randomInts(2);
  return `${WORDS[a[0] % WORDS.length]}-${(a[1] % 900) + 100}`;
}

// Friendly input: "rocket 472", "Rocket_472" and "ROCKET472" all become "ROCKET-472".
export function normaliseRoomCode(s) {
  const t = String(s || '').trim().toUpperCase().replace(/[\s_]+/g, '-').replace(/-+/g, '-');
  const m = t.match(/^([A-Z]{2,12})-?(\d{3})$/);
  return m ? `${m[1]}-${m[2]}` : null;
}

// Names: letters, numbers, spaces, _ and - only; single spaces; 12 characters.
export function sanitiseName(s) {
  return String(s || '')
    .replace(/[^\p{L}\p{N} _-]/gu, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 12)
    .trim();
}

// The same child must always get the same identity, whatever case or spacing they type.
export function nameKey(s) {
  return sanitiseName(s).normalize('NFKC').toLowerCase();
}

// A small, deliberately cautious filter for names other children will see.
const BLOCK_ANYWHERE = ['fuck', 'shit', 'cunt', 'bitch', 'bastard', 'wank', 'twat', 'bollock', 'slut', 'whore', 'nigg', 'retard', 'penis', 'vagina', 'porn', 'hitler', 'asshole', 'arsehole', 'dildo', 'boner', 'horny'];
const BLOCK_WORDS = new Set(['ass', 'arse', 'butt', 'bum', 'poo', 'poop', 'pee', 'piss', 'crap', 'tit', 'tits', 'boob', 'boobs', 'sex', 'sexy', 'dick', 'cock', 'pussy', 'rape', 'nazi', 'kkk', 'fag', 'idiot', 'stupid', 'dumb', 'loser', 'ugly', 'kill', 'die', 'hate']);

export function nameAllowed(s) {
  const clean = sanitiseName(s);
  if (clean.length < 2) return false;
  const lower = clean.toLowerCase();
  const squashed = lower.replace(/[\s_-]+/g, '');
  if (BLOCK_ANYWHERE.some((w) => squashed.includes(w))) return false;
  return !lower.split(/[\s_-]+/).some((w) => BLOCK_WORDS.has(w));
}

// Birthday month and year as MMYY, e.g. March 2018 -> "0318".
export function mmyyFrom(month, year) {
  const m = Number(month), y = Number(year);
  if (!Number.isInteger(m) || m < 1 || m > 12 || !Number.isInteger(y) || y < 0) return null;
  return `${String(m).padStart(2, '0')}${String(y % 100).padStart(2, '0')}`;
}

export function validMMYY(s) {
  return /^(0[1-9]|1[0-2])\d{2}$/.test(String(s || ''));
}
